import React, { useState, useEffect, useMemo } from "react";
import { TagIcon } from "@heroicons/react/16/solid";
import { api } from "../../api";
import { transformFiltersToGelly } from "./filterToGelly";
import { Button } from "../tailwind/button";

const ContactCount = ({
  filterGroups,
  onAddTag,
  isGeneratingFilters = false,
  onCountChange,
}) => {
  const [data, setData] = useState(null);
  const [fetching, setFetching] = useState(false);
  const [error, setError] = useState(null);

  // Memoize the Gelly query to prevent recalculation on every render
  const gellyQuery = useMemo(() => {
    return transformFiltersToGelly(filterGroups);
  }, [filterGroups]);

  // Use inline computed view to get contact count
  useEffect(() => {
    const fetchContactCount = async () => {
      setFetching(true);
      setError(null);

      try {
        const result = await api.view(gellyQuery);
        console.log("Contact count result:", result);
        setData(result);
      } catch (err) {
        console.error("Contact count error:", err);
        setError(err);
      } finally {
        setFetching(false);
      }
    };

    fetchContactCount();
  }, [gellyQuery]);

  console.log("Gelly query:", gellyQuery);
  console.log("Data:", data);

  // Get the count value from the new nested structure with alias
  // New structure: { contacts: { totalCount: 1234 } }
  // Old structure: { "count(contacts)": 1234 }
  let count = 0;
  if (data) {
    if (data.contacts && data.contacts.totalCount !== undefined) {
      // New nested structure with alias
      count = data.contacts.totalCount;
    } else {
      // Fallback to old structure or first value
      count = Object.values(data)[0] || 0;
    }
  }

  // Notify parent component of count changes
  useEffect(() => {
    if (onCountChange && !fetching && !error) {
      onCountChange(count);
    }
  }, [count, onCountChange, fetching, error]);

  if (fetching) {
    return (
      <div className="text-lg border-t border-gray-200 text-gray-500 py-2 h-14 flex items-center">
        Counting contacts...
      </div>
    );
  }

  if (error) {
    console.error("Contact count error:", error);
    return (
      <div className="text-lg border-t border-gray-200 text-red-500 py-2 h-14 flex items-center">
        Error counting contacts
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3 py-2 border-t border-gray-200 h-14">
      <div className="text-lg text-gray-600 font-bold">
        <span>{count}</span> contact
        {count !== 1 ? "s" : ""}
      </div>
      {count > 0 && onAddTag && (
        <Button
          color="secondaryButton"
          onClick={() => onAddTag(filterGroups, count)}
          className="text-sm flex items-center gap-1"
          disabled={fetching || isGeneratingFilters}
        >
          <TagIcon className="h-4 w-4" />
          Add tag
        </Button>
      )}
    </div>
  );
};

export default ContactCount;
